import Modal from "../../../controls/Modal";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import { activeGameId, currentGameDiscovery, modPathsForGame, } from "../../../util/selectors";
import { truthy } from "../../../util/util";
import { getGame } from "../../gamemode_management/util/getGame";
import { setDeploymentProblem } from "../actions/session";
import allTypesSupported from "../util/allTypesSupported";
import { getAllActivators } from "../util/deploymentMethods";
import * as React from "react";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";
import { log } from "../../../util/log";
function nop() {
    // nop
}
class FixDeploymentDialog extends ComponentEx {
    deploymentMethods;
    constructor(props) {
        super(props);
        this.initState({
            step: -1,
        });
        this.deploymentMethods = getAllActivators();
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.problems !== newProps.problems) {
            this.nextState.step = -1;
        }
    }
    render() {
        const { t, gameId, problems } = this.props;
        const { step } = this.state;
        const automaticFix = step !== -1 && problems[step].hasAutomaticFix;
        return (React.createElement(Modal, { id: "fix-deployment-dialog", show: gameId !== undefined && problems.length > 0, onHide: nop },
            React.createElement(Modal.Header, null,
                React.createElement(Modal.Title, null, t("Deployment Methods"))),
            React.createElement(Modal.Body, null, step === -1 ? this.renderStartPage() : this.renderFixPage()),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { onClick: this.cancel }, t("Close")),
                React.createElement(Button, { onClick: this.back, disabled: step <= 0 }, t("Back")),
                React.createElement(Button, { onClick: this.applyFix, disabled: !automaticFix }, t("Apply Fix")),
                React.createElement(Button, { onClick: this.next, disabled: step >= problems.length - 1 }, t("Next")))));
    }
    renderStartPage() {
        return (
        // tslint:disable:max-line-length
        React.createElement(Trans, { i18nKey: "fix-deployment-instructions" },
            "Vortex supports different Deployment Methods to support a wide variety of systems and games, but some may only be available with the right settings.",
            React.createElement("br", null),
            "Right now, none of the available deployment methods seem to be usable, but this is usually easy to fix.",
            React.createElement("br", null),
            "On the following screens we will offer possible solutions, simplest one first.")
        // tslint:enable:max-line-length
        );
    }
    renderFixPage() {
        const { t, problems } = this.props;
        const { step } = this.state;
        const method = this.deploymentMethods.find((iter) => iter.id === problems[step].activator);
        return (React.createElement("div", null,
            React.createElement("h3", null, method.name),
            React.createElement("h5", null, t("Problem")),
            React.createElement("div", null, problems[step].message),
            React.createElement("h5", null, t("Solution")),
            React.createElement("div", null, problems[step].solution !== undefined
                ? problems[step].solution
                : t("Can't be solved."))));
    }
    applyFix = () => {
        const { t, gameId, problems, onClear } = this.props;
        const { step } = this.state;
        const method = this.deploymentMethods.find((iter) => iter.id === problems[step].activator);
        const state = this.context.api.store.getState();
        if (gameId === undefined) {
            // the dialog shouldn't have been shown if there is no game active
            return;
        }
        const modPaths = modPathsForGame(state, gameId);
        if (truthy(modPaths)) {
            // we have to find the unavailable reason again because the data we have doesn't contain
            // the actual fix function (since we can't put functions into the store)
            // However, it's technically possible that we find a different fail reason this time around
            // and that may not have a fix callback
            const reason = allTypesSupported(method, state, gameId, Object.keys(modPaths));
            if (reason.errors.length === 0) {
                // the failure no longer applies? Hrmm...
                log("warn", "The reason the deployment method was unavailable was apparently temporary", { reason: method.description });
                onClear();
            }
            else if (reason.errors[0].fixCallback !== undefined) {
                onClear();
                return reason.errors[0].fixCallback(this.context.api);
            }
            else {
                onClear();
                this.context.api.sendNotification({
                    type: "warning",
                    message: "The reason this deployment method is unavailable has changed since the " +
                        "notification was produced. This indicates a random or temporary factor " +
                        "affecting it.",
                });
                log("warn", "The reason the deployment method is unavailable changed", {
                    before: method.description,
                    after: reason.errors[0].description(t),
                });
            }
        }
        else {
            const discovery = currentGameDiscovery(state);
            this.context.api.showErrorNotification("Failed to apply fix", {
                gameId,
                activator: problems[step].activator,
                gameFound: getGame(gameId) !== undefined,
                discoveryFound: discovery !== undefined && discovery.path !== undefined,
            });
            onClear();
        }
    };
    cancel = () => {
        this.props.onClear();
    };
    back = () => {
        this.nextState.step--;
    };
    next = () => {
        this.nextState.step++;
    };
}
function mapStateToProps(state) {
    return {
        problems: state.session.mods.deploymentProblems,
        gameId: activeGameId(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onClear: () => dispatch(setDeploymentProblem([])),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(FixDeploymentDialog));
